import { PrizeFormType } from '../../model/prize';

export const useCreatePrizeCardDefaultValues = (): PrizeFormType => ({
  prize_type_id: null,
  min_start_date: '',
  max_end_date: '',
  name_ru: '',
  name_kz: '',
  name_uz: '',
  name_kg: '',
  description_ru: '',
  description_kz: '',
  description_uz: '',
  description_kg: '',
  category: '',
  image: null,
  icon: null,
  prize_file: null,
  is_generated: false,
});
